import React from "react"
import TextField from "@mui/material/TextField"
import { styled } from "@mui/material/styles"

const UserTextField = (props: any) => {
  const CssTextField = styled(TextField)({
    "& label.Mui-focused": {
      color: "#000000",
      fontWeight: "700",
      fontSize: "20px",
      backgroundColor: "white",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#29223E",
      },
      "&:hover fieldset": {
        borderColor: "#B2BAC2",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#29223E",
      },
    },
  })
  return (
    <div>
      <CssTextField
        className={props.className}
        id="custom-css-outlined-input"
        label={props.label}
        value={props.value}
        name={props.name || ""}
        defaultValue={props.defaultValue}
        InputProps={{
          readOnly: props.readOnly || false,
        }}
        focused
        onChange={props.onChange}
      />
    </div>
  )
}

export default UserTextField
